const formErrors = state => state.formErrors;

export default formErrors;
